import { render, staticRenderFns } from "./FileThumbnail.vue?vue&type=template&id=3ed4b92d&scoped=true"
import script from "./FileThumbnail.vue?vue&type=script&lang=ts"
export * from "./FileThumbnail.vue?vue&type=script&lang=ts"
import style0 from "./FileThumbnail.vue?vue&type=style&index=0&id=3ed4b92d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed4b92d",
  null
  
)

export default component.exports